// this prevents overwriting
let previousOverflow

export function lockPage() {
    const body = document.querySelector('body')
    if (body.style.overflow !== 'hidden') {
        previousOverflow = body.style.overflow
    }
    body.style.overflow = 'hidden'
}

export function unlockPage() {
    const body = document.querySelector('body')
    body.style.overflow = previousOverflow
}
